/** A token's last working day: a native date picker bounded in UTC, with the info tip and the "Works through" line. */

import { FieldLabel } from '@/ui/FieldLabel';

import { worksThrough } from './mcpScopes';

export function isDayInRange(day: string, min: string, max: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(day) && day >= min && day <= max;
}

export function ExpiryField({
  id,
  label,
  tip,
  value,
  min,
  max,
  error,
  onChange,
  autoFocus = false,
}: {
  id: string;
  label: string;
  tip: string;
  value: string;
  min: string;
  max: string;
  /** What is wrong with the value, shown instead of the "Works through" line. */
  error: string;
  onChange: (day: string) => void;
  autoFocus?: boolean;
}) {
  const valid = isDayInRange(value, min, max);
  return (
    <div className="field">
      <FieldLabel htmlFor={id} id={`${id}-tip`} label={label} hint={tip} />
      <input
        id={id}
        type="date"
        min={min}
        max={max}
        required
        autoFocus={autoFocus}
        className={valid ? undefined : 'has-error'}
        aria-invalid={valid ? undefined : true}
        aria-describedby={`${id}-tip ${id}-note`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <span id={`${id}-note`} className={valid ? 'hint' : 'field-error'}>
        {valid ? worksThrough(value) : error}
      </span>
    </div>
  );
}
